import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = "Loading…" }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center py-12 text-muted-foreground"
    >
      <Loader2 className="h-6 w-6 animate-spin mb-2" aria-hidden="true" />
      <span className="text-sm">{message}</span>
    </div>
  );
}
